<script>
import ChargemapModal from "../global/ChargemapModal.vue";
export default {
  name: "PoolPricesModal",
  components: { ChargemapModal },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showPricesModal: {
      type: Boolean,
      default: false
    },
    pricesModalHTML: {
      type: String,
      default: ""
    },
    poolId: {
      type: Number,
      required: true
    }
  },
  emits: ["updateShowPricesModal"],
  methods: {
    updateShowPricesModal(val) {
      this.$emit("updateShowPricesModal", val);
    }
  }
};
</script>

<template>
    <ChargemapModal
        v-if="showPricesModal"
        :show-x="true"
        @updateIsVisible="updateShowPricesModal"
    >
        <template #title>
            <slot name="title" />
        </template>
        <IconLoader
            v-show="loading"
            class="size-5 m-auto text-gray-500 animate-spin"
        />
        <iframe
            :id="`prices-modal-${poolId}`"
            class="prices-modals"
            :srcdoc="pricesModalHTML"
        ></iframe>
    </ChargemapModal>
</template>

<style>
.prices-modals{border:0;transition:all .3s ease-in-out;width:100%}
</style>
